<!--
 * @Author: cmchiu
 * @Date: 2023-05-05 10:02:32
 * @LastEditTime: 2023-07-04 14:29:58
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\ProjectSearch.vue
 * 
-->
<template>
    <div class="project-search">
        <breadcrumb />

        <div class="layer-container">
            <h2 class="page-title">技術研究與產學計畫</h2>
            <div class="research">
                <!-- Advanced Search Bar -->
                <div class="advanced-search w-100 d-flex">
                    <select class="advanced-search__select" v-model="project.filter.projGroup" @change="getProjLs(1)">
                        <option value="20">研究計畫</option>
                        <option value="10">產學計畫</option>
                        <option value="all">全部分類</option>
                    </select>
                    <input
                        class="advanced-search__input"
                        type="search"
                        id="search"
                        name="search"
                        placeholder="教師名稱、學院、系所"
                        v-model.trim="project.filter.keyword"
                        @keyup.enter="getProjLs(1)"
                        @change="getProjLs(1)"
                    />
                    <button class="advanced-search__button" @click="getProjLs()">搜 尋</button>
                </div>
                <!-- Research -->
                <div class="research__wrapper">
                    <h3
                        class="page-subtitle"
                        v-text="
                            project.filter.projGroup === '10'
                                ? '產學計畫'
                                : project.filter.projGroup === '20'
                                ? '研究計畫'
                                : '研究與產學計畫'
                        "
                    ></h3>
                    <table class="info-table">
                        <thead>
                            <tr>
                                <th>編碼</th>
                                <th v-if="project.filter.projGroup === 'all'">計畫分類</th>
                                <th>計畫名稱</th>
                                <th>主持人</th>
                                <th>系所</th>
                                <th>學院</th>
                                <th>計畫起始日</th>
                                <th>計畫結束日</th>
                                <th>計畫類別</th>
                                <th>補助/合作單位</th>
                                <th>計畫經費</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in project.data" :key="row.sno">
                                <td v-text="row.ID"></td>
                                <td v-if="project.filter.projGroup === 'all'" v-text="row.ProjGroupName"></td>
                                <td v-text="row.ProjTitle"></td>
                                <td v-text="row.DirectorName"></td>
                                <td v-text="row.Dep"></td>
                                <td v-text="row.College"></td>
                                <td v-text="row.ProjDateS"></td>
                                <td v-text="row.ProjDateE"></td>
                                <td v-text="row.ProjTypeName"></td>
                                <td v-text="row.RelUnit"></td>
                                <td v-html="'$&nbsp;' + formatAmount(row.TotalFunding)"></td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination
                        :page-size="project.pages.pageSize"
                        :total.sync="project.pages.totalResult"
                        :currPage.sync="project.pages.pageCurrent"
                        @page-change="pageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatAmount } from '@/utils/common'
import { getProjLs } from '@/api/project'
import { breadcrumb, pagination } from '@c'

export default {
    name: 'projectSearch',

    components: { breadcrumb, pagination },

    data() {
        const vm = this
        const rParas = vm.$route.params

        return {
            configs: {
                loading: false,
            },
            project: {
                filter: {
                    projGroup: !rParas.keyword ? '20' : 'all',
                    keyword: !rParas.keyword ? '' : rParas.keyword,
                },
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 9, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
        }
    },

    created() {
        this.getProjLs(1)
    },

    methods: {
        async getProjLs(chgFilters) {
            const vm = this
            const filter = vm.project.filter
            const pages = vm.project.pages
            vm.configs.loading = true
            if (chgFilters) pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                ProjGroup: filter.projGroup,
                Keyword: filter.keyword,
                PageSize: pages.pageSize,
                PageCurrent: pages.pageCurrent,
            }
            await getProjLs(params)
                .then(res => {
                    // handle success
                    vm.project.data = res.Items
                    pages.totalResult = res.TotalResult
                    if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.project.data = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        pageChange(val) {
            this.project.pages.pageCurrent = val
            this.getProjLs()
        },

        formatAmount,
    },
}
</script>
